import * as React from 'react'

import './styles.scss'
import ToggleSwitch from './ToggleSwitch'
import { lang } from 'utils/helpers'

const ConversationsNotificationsCard = ({
  textMsg,
  note,
  voiceNote,
  pdf,
  imageVideo,
  location,
  setChecked
}) => (
  <div className='conversations-notifications-card'>
    <div className='title-section'>
      <p className='title'>
        {lang('notifications_view_conversations_card_title')}
      </p>
      <p className='subtitle'>
        {lang('notifications_view_conversations_card_subtitle')}
      </p>
    </div>
    <div className='conversations-options-section'>
      <div className='switch-row'>
        <ToggleSwitch
          checked={!!textMsg}
          onChange={({ value }) => setChecked({ fieldName: 'textMsg', fieldValue: value })}
          switchTitle={lang('dashboard_text-messages')}
        />
        <ToggleSwitch
          checked={!!note}
          onChange={({ value }) => setChecked({ fieldName: 'note', fieldValue: value })}
          switchTitle={lang('dashboard_internal-notes')}
        />
        <ToggleSwitch
          checked={!!voiceNote}
          onChange={({ value }) => setChecked({ fieldName: 'voiceNote', fieldValue: value })}
          switchTitle={lang('dashboard_voice-notes')}
        />
      </div>
      <div className='switch-row'>
        <ToggleSwitch
          checked={!!pdf}
          onChange={({ value }) => setChecked({ fieldName: 'pdf', fieldValue: value })}
          switchTitle={lang('dashboard_pdf')}
        />
        <ToggleSwitch
          checked={!!imageVideo}
          onChange={({ value }) => setChecked({ fieldName: 'imageVideo', fieldValue: value })}
          switchTitle={lang('dashboard_images-gifs-videos')}
        />
        <ToggleSwitch
          checked={!!location}
          onChange={({ value }) => setChecked({ fieldName: 'location', fieldValue: value })}
          switchTitle={lang('dashboard_locations')}
        />
      </div>
    </div>
  </div>
)

export default ConversationsNotificationsCard
